import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Lock from "rialto-icons/Lock";

import Avatar from "components/Avatar";
import Timestamp from "components/Timestamp";
import Translate from "utils/translate";

import styles from "./UserDetails.css";

const { t } = new Translate("UserDetails");

const UserDetails = (props) => {
  const {
    dateTime,
    dateTimeEdit,
    dateTimeOriginal,
    isOneLined,
    isPrivate,
    isTextHidden,
    title,
    user,
  } = props;

  if (!user) return null;

  return (
    <div
      className={cx(styles.wrapper, {
        [styles.greyedOut]: user.deleted,
        [styles.oneLined]: isOneLined,
      })}
    >
      <Avatar
        fname={user.fname}
        isCurrentUser={false}
        isDeleted={user.deleted}
        lname={user.lname}
        size={isOneLined ? "" : "large"}
        src={user.profilePictureUrl}
      />
      {!isTextHidden && (
        <div className={styles.textWrapper}>
          <div className={styles.name}>
            {user.deleted ? t("deletedUser") : `${user.fname || ""} ${user.lname || ""}`}
          </div>
          <div className={styles.subText}>
            {title || (
              <Timestamp
                createdAt={dateTime}
                original={dateTimeOriginal}
                updatedAt={dateTimeEdit}
              />
            )}
            {isPrivate && isOneLined && <Lock size="xs" />}
          </div>
        </div>
      )}
    </div>
  );
};

UserDetails.propTypes = {
  user: PropTypes.shape({
    fname: PropTypes.string,
    lname: PropTypes.string,
    email: PropTypes.string,
    profilePictureUrl: PropTypes.string,
    deleted: PropTypes.bool,
  }),
  dateTime: PropTypes.string,
  dateTimeEdit: PropTypes.string,
  dateTimeOriginal: PropTypes.string,
  title: PropTypes.string,
  isOneLined: PropTypes.bool,
  isTextHidden: PropTypes.bool,
  isPrivate: PropTypes.bool,
};

export default UserDetails;
